import React from 'react';
import StepperListItem from './StepperListItem';
import { t } from 'ttag';

export default class StepperSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  getType = (currentStep, stepperPosition) => {
    if(stepperPosition - currentStep < 0) return 'DONE';
    if(stepperPosition - currentStep > 0) return 'PENDING'
    if(currentStep === 5) {
      return 'DONE'
    } else {
      return 'CURRENT'
    }
  }

  render() {
    const {
      currentStep,
      children
    } = this.props;

    return (
      <React.Fragment>
        <div className="wrapper">
          <nav className="stepper">
            <ul className="stepper__list">
              <StepperListItem title={t`1. Helyválasztás`} type={this.getType(currentStep, 1)} />
              <StepperListItem title={t`2. Adatok megadása`} type={this.getType(currentStep, 2)} />
              <StepperListItem title={t`3. Rendeléstípus választása`} type={this.getType(currentStep, 3)} />
              <StepperListItem title={t`4. Áttekintés és véglegesítés`} type={this.getType(currentStep, 4)} />
              <StepperListItem title={t`5 .Visszaigazolás`} type={this.getType(currentStep, 5)} />
            </ul>
          </nav>
        </div>
        {children}
      </React.Fragment>
    );
  }
}


